var _clipPath, _tspan;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrubbyBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 303 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 303,
    height: 80.527,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard11",
    x: 0,
    y: 0,
    width: 303,
    height: 80.527
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glasses"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.27,
    y: 30.989,
    width: 24.199,
    height: 3.505,
    style: {
      fill: "#51697b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.971,44.743l13.545,-8.699l13.545,8.699l0,3.525l-13.545,-8.699l-13.545,8.699l0,-3.525Z",
    style: {
      fill: "#51697b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.92,30.866l4.606,-6.651l2.735,0l3.068,8.527l-2.597,1.388l-2.07,-6.29l-3.48,4.902l-2.262,-1.876Z",
    style: {
      fill: "#51697b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.788,29.619l5.95,6.425l1.799,-3.302l-7.197,-7.222l-3.095,0l-1.689,10.524l3.454,0.442l0.778,-6.867Z",
    style: {
      fill: "#51697b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eye"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.48,
    cy: 42.921,
    rx: 14.726,
    ry: 14.351,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iris"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.377,
    cy: 43.671,
    r: 9.327,
    style: {
      fill: "#51697b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.377,
    cy: 43.671,
    r: 5.65,
    style: {
      fill: "#4a82ae"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Eye-Shine"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.651,
    cy: 39.944,
    r: 1.923,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.433,
    cy: 38.021,
    r: 0.672,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.706,
    cy: 49.32,
    r: 1.343,
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Eye1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.194,
    cy: 43.671,
    rx: 14.726,
    ry: 14.351,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iris1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.092,
    cy: 44.421,
    r: 9.327,
    style: {
      fill: "#51697b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.092,
    cy: 44.421,
    r: 5.65,
    style: {
      fill: "#4a82ae"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Eye-Shine1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 234.365,
    cy: 40.694,
    r: 1.923,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.147,
    cy: 38.771,
    r: 0.672,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.42,
    cy: 50.07,
    r: 1.343,
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("text", {
    x: "-3.576px",
    y: "62.206px",
    style: {
      fontFamily: "'TwCenMT-Regular', 'Tw Cen MT', sans-serif",
      fontSize: "96.954px",
      fill: "#4a82ae"
    }
  }, "S", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "44.603px 81.678px 115.695px 157.899px 210.124px 258.491px ",
    y: "62.206px 62.206px 62.206px 62.206px 62.206px 62.206px "
  }, "crubby")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrubbyBar);
export default __webpack_public_path__ + "static/media/ScrubbyBar.83d89025.svg";
export { ForwardRef as ReactComponent };